export default __webpack_public_path__ + "static/media/icon-2-green-round.72f05b19.svg";